import { type FC } from 'react';
import { Form } from 'react-bootstrap';
import * as uuid from 'uuid';

import { isExactMatchConfigValidation } from '@editor2/services/elementValidationsService';
import { InfoTooltip } from './InfoTooltip';
import { type ResponseBoard, type SAQuestion } from '@editor2/types/pageElements';

interface Props {
	element: SAQuestion | ResponseBoard;
}

export const ImmutableExactMatchValidations: FC<Props> = ({ element }) => {
	return (
		<ul>
			{element.validations.map((validation, index) => {
				return (
					isExactMatchConfigValidation(validation) && (
						<li key={`config-validation-${index}`}>
							<span className="exact-match-parameters-ro">
								<span>
									{validation.parameters?.['match-expression']}{' '}
									<InfoTooltip validationName="match-expression" />
								</span>
								<span className="exact-match-boolean-parameters-ro">
									<Form.Check
										id={uuid.v4()}
										type="switch"
										checked={validation.parameters?.['partial-match']}
										disabled={true}
										label={
											<span>
												Partial Match <InfoTooltip validationName="partial-match" />
												&nbsp;
											</span>
										}
										className="enableSwitch"
									/>
									<Form.Check
										id={uuid.v4()}
										type="switch"
										checked={validation.parameters?.['reject']}
										disabled={true}
										label={
											<span>
												Reject <InfoTooltip validationName="reject-match" />
											</span>
										}
										className="enableSwitch"
									/>
								</span>
							</span>
						</li>
					)
				);
			})}
		</ul>
	);
};
